module.exports = __webpack_public_path__ + "media/images/Powered_By_Flag_75x40-f209270a704fc3a0e18814793775a94c.png";